import React, { forwardRef, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'contexts'
import styles from './Cover.module.scss'

const Cover = forwardRef((props, ref) => {
  const { t } = useTranslation()
  const { formData } = useForm()
  const { author, title, subtitle, details = [], image } = formData
  const imageUrl = useMemo(() => (image ? URL.createObjectURL(image) : null), [
    image,
  ])

  return (
    <div className={styles.content}>
      <div className={styles.container}>
        <div className={styles.cover} ref={ref}>
          <div className={styles.image}>
            <div
              className={styles.file}
              style={{
                backgroundImage: image ? `url('${imageUrl}')` : undefined,
              }}
            />
          </div>
          <div className={styles.banner}>
            <span className={styles.penguin}>{t('cover.penguin')}</span>
            <span className={styles.logo} />
            <span className={styles.classics}>{t('cover.classics')}</span>
          </div>
          <div className={styles.text}>
            {author && <span className={styles.author}>{author}</span>}
            <div className={styles.titles}>
              {title && <span className={styles.title}>{title}</span>}
              {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
            </div>
            {details.length > 0 && (
              <div className={styles.details}>
                {details.map((detail, index) => (
                  <span key={index} className={styles.detail}>
                    {detail}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
})

export default Cover
